import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

// 添加条件
@Component({
  selector: 'm-rules-add',
  template: `
    <i class="m-rules-add-icon">
      <svg
        width="14px"
        height="14px"
        viewBox="0 0 14 14"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g id="页面" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="05-03-新建规则组/最多2个添加条件" transform="translate(-275.000000, -725.000000)">
            <g id="-mockplus-" transform="translate(265.000000, 536.000000)">
              <g id="编组-4" transform="translate(8.000000, 31.000000)">
                <g id="编组-2" transform="translate(0.000000, 47.000000)">
                  <g id="-mockplus-" transform="translate(0.000000, 107.000000)">
                    <g id="Icon/Line/universal/filter" transform="translate(2.000000, 4.000000)">
                      <rect id="矩形" fill="#000000" fill-rule="nonzero" opacity="0" x="0" y="0" width="14" height="14"></rect>
                      <path
                        d="M12.585981,1.75 L1.75,1.75 L5.59828496,7.09124695 L5.59828496,12.25 L8.70456409,9.92029066 L8.70456409,7.13007544 L12.585981,1.75 Z M3.26624591,2.52656978 L11.0684425,2.52656978 L7.9279943,6.88020502 L7.9279943,9.53200577 L6.37485474,10.6968604 L6.37485474,6.84071825 L3.26624591,2.52656978 Z"
                        id="路径"
                        fill="#107CEE"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </i>
    <span>添加条件</span>
  `,
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'm-rules-add'
  }
})
export class MRulesAddComponent {}
